import { render, staticRenderFns } from "./fpSideIcon.vue?vue&type=template&id=8e25e66e&scoped=true&"
import script from "./fpSideIcon.vue?vue&type=script&lang=js&"
export * from "./fpSideIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e25e66e",
  null
  
)

export default component.exports